import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';

type OptionalCallback = undefined | (() => void);

const useHttpPatchMarkNotificationAsRead = () => {
    const userApi: UserApi = useContainer(UserApi);

    const execPatch = (id: string, successCallback: OptionalCallback = undefined) => {
        const { exec, clearCache, abort } = userApi.markNotificationAsRead({
            params: {
                id,
            },
            onSuccess: () => {
                if (successCallback) successCallback();
                clearCache();
                return `Notification successfully make as read!`;
            },
            onError: error => error,
        });
        exec();
        return abort;
    };

    return { execPatch };
};

export default useHttpPatchMarkNotificationAsRead;
